import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import React from 'react';

type FilterSliderProps = {
  filterName: string;
  value: number | number[];
  min?: number;
  max?: number;
  step?: number;
  /** Named above the slider, since a slider has no field to hold a label. */
  label: string;
  disabled?: boolean;
  onChange: (filterName: string, value: number | number[]) => void;
};

export default function FilterSlider(props: Readonly<FilterSliderProps>) {
  const {
    filterName,
    min,
    max,
    step,
    label,
    disabled,
    onChange
  } = props;

  const [value, setValue] = React.useState<number | number[]>(props.value);

  const range = Array.isArray(value) ? `${value[0]} – ${value[1]}` : String(value);

  return (
    <div style={{ width: '100%' }}>
    <Typography variant="caption" color="text.secondary" component="div" id={`${filterName}-label`}>
      {label}: {range}
    </Typography>
    <Slider
      name={filterName}
      aria-labelledby={`${filterName}-label`}
      disabled={disabled}
      size="small"
      valueLabelDisplay="auto"
      value={value}
      onChange={(_event, value) => {
        setValue(value);
      }}
      onChangeCommitted={(event, value) => {
        onChange(filterName, value)
      }}
      min={min}
      max={max}
      step={step}
      sx={{ width: '100%' }}
    />
    </div>
  )
}
